export default __webpack_public_path__ + "static/btn-mail-white-7e342c984195423dc696c47fab0b256c.png";